const midColumn = ({ name = "mid", placeholder = "MID" } = {}) => ({
	name,
	type: "input" as const,
	placeholder,
});

export default midColumn;
